import { useAuthStore } from './auth-store';
import type { Action, Resource } from './permissions';

export function useCan(resource: Resource, action: Action): boolean {
  return useAuthStore((s) => s.can(resource, action));
}
